import React, { useState } from "react";
import { connect } from "react-redux";
import objectPath from "object-path";
import Topbar from "./Topbar";
import HMenu from "./HMenu/HMenu";
import AnimateLoading from "../../../app/partials/layout/AnimateLoading";
import KTHeader from "../../_assets/js/header";
import * as builder from "../../ducks/builder";
import GpsNoticeBanner from "../../sharedcomponent/GpsNoticeBanner";

// ── Set to false to remove the banner when situation is back to normal ──
const SHOW_GPS_NOTICE = true;

// ── GPS Notice Banner (inline – no separate file needed) ──
// const GpsNoticeBanner = () => {
//   const [visible, setVisible] = useState(true);

//   if (!SHOW_GPS_NOTICE || !visible) return null;

//   return (
//     <div style={bannerStyles.wrapper}>
//       <div style={bannerStyles.content}>
//         {/* Blinking warning icon */}
//         <span style={bannerStyles.icon}>⚠</span>
//         <span style={bannerStyles.text}>
//           <strong style={bannerStyles.strong}>NOTICE:</strong>
//           Due to the ongoing regional security situation, GPS signals may be
//           jammed, degraded, or temporarily unavailable in areas near sensitive
//           installations. As a result, the vehicle location displayed on the map
//           may be inaccurate or delayed at times. We appreciate your
//           understanding.
//         </span>
//       </div>
//       <button
//         style={bannerStyles.closeBtn}
//         onClick={() => setVisible(false)}
//         title="Dismiss"
//         aria-label="Dismiss GPS notice"
//         onMouseEnter={e =>
//           (e.currentTarget.style.background = "rgba(255,255,255,0.18)")
//         }
//         onMouseLeave={e =>
//           (e.currentTarget.style.background = "transparent")
//         }
//       >
//         ✕
//       </button>
//     </div>
//   );
// };

// ── Inline styles (lighter brown palette) ──
// const bannerStyles = {
//   wrapper: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     background: "linear-gradient(135deg, #b5622e 0%, #d4884e 50%, #b5622e 100%)",
//     color: "#fff8f0",
//     padding: "7px 16px",
//     width: "100%",
//     boxSizing: "border-box",
//     borderBottom: "2px solid #e8a070",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
//     zIndex: 1100,
//   },
//   content: {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//     flex: 1,
//     minWidth: 0,
//   },
//   icon: {
//     color: "#ffd199",
//     fontSize: "18px",
//     flexShrink: 0,
//     animation: "gps_blink 1.6s ease-in-out infinite",
//   },
//   text: {
//     fontSize: "12.5px",
//     lineHeight: "1.55",
//     letterSpacing: "0.2px",
//     color: "#fff3e8",
//   },
//   strong: {
//     fontWeight: 700,
//     color: "#ffd199",
//     marginRight: "5px",
//   },
//   closeBtn: {
//     background: "transparent",
//     border: "none",
//     cursor: "pointer",
//     color: "#ffd199",
//     fontSize: "14px",
//     padding: "2px 6px",
//     marginLeft: "12px",
//     borderRadius: "3px",
//     flexShrink: 0,
//     lineHeight: 1,
//     transition: "background 0.2s",
//   },
// };

// ── Main Header Class Component ──
class Header extends React.Component {
  headerCommonRef = React.createRef();

  componentDidMount() {
    let options = {};
    if (
      this.headerCommonRef.current.getAttribute("data-ktheader-minimize") ===
      "1"
    ) {
      options["minimize.desktop.on"] = "kt-header--minimize";
      options["offset.desktop"] = 130;
    }

    // eslint-disable-next-line no-undef
    new KTHeader(this.headerCommonRef.current, options);
  }

  render() {
    const { menuHeaderDisplay, headerAttributes, headerClasses } = this.props;
    return (
      <>
        {/* GPS Notice Banner – auto-dismisses after 30 seconds */}
       <GpsNoticeBanner /> 

        <div
          className={`kt-header kt-grid__item ${headerClasses}`}
          id="kt_header"
          ref={this.headerCommonRef}
          {...headerAttributes}
        >
          <AnimateLoading />
          {/* begin: Header Menu */}
          {menuHeaderDisplay && <HMenu />}
          {/* end: Header Menu */}
          {/* begin: Header Topbar */}
          {!menuHeaderDisplay && <div />}
          <Topbar />
          {/* end: Header Topbar */}
        </div>
      </>
    );
  }
}

const mapStateToProps = store => ({
  headerClasses: builder.selectors.getClasses(store, {
    path: "header",
    toString: true
  }),
  headerAttributes: builder.selectors.getAttributes(store, { path: "header" }),
  menuHeaderDisplay: objectPath.get(
    store.builder.layoutConfig,
    "header.menu.self.display"
  ),
  fluid:
    objectPath.get(store.builder.layoutConfig, "header.self.width") === "fluid"
});

export default connect(mapStateToProps)(Header);
